



















































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import { auth } from "@/configs/firebase";
import { User } from "@/types";
import { Routes } from "@/router/routes";
import AOS from "aos";

import "./styles/landing-page.scss";
import "aos/dist/aos.css";

AOS.init();

@Component
export default class Home extends Vue {
  testimonials: { name: string; quote: string }[] = [
    {
      name: "Jason",
      quote:
        "I have always been frustrated with the numerous phone calls it takes to find health insurance, but after speaking with an Insurita liscenced agent, I finally got my first ever insurance plan. I just love how they provided a one call resolution!"
    },
    {
      name: "Kate",
      quote:
        "Got my family a new insurance plan at Insurita! Finally a company that's straightforward. The agent I talked to was very relatable, she helped me in every step of the way. I'm very happy to have found Insurita."
    },
    {
      name: "Riley",
      quote:
        "Insurita saved me so much time. It is my first time trying to get an insurance plan for the whole family and everyone was covered in just under 24 hours. They were also so welcoming and made me feel like I have nothing to worry about."
    }
  ];

  faqs: { title: string; description: string }[] = [
    {
      title: "What insurance plans do you offer?",
      description:
        "As of now we only focus on a variety health insurance plans! But make sure to keep an eye out for us in the future, we are also looking into adding more kinds of plans so that we can cater all those to you."
    },
    {
      title: "How does Insurita process work for Insurance?",
      description:
        "Here at Insurita, we begin by assessing your insurance needs as well as the coverage to which you may apply based on a number of factors including your age, health, and affordability. No worries, we will hold your hand throughout the whole process."
    },
    {
      title: "How fast can I get covered?",
      description:
        "The coverage time for each product varies according to your qualifications. We will make sure  to get you the right level of insurance as soon as possible. For many customers this means getting insurance same day."
    },
    {
      title: "Can I purchase online?",
      description:
        "As of now, the best way for you to purchase our products is through speaking with a liscenced agent."
    },
    {
      title: "Do you have customer service?",
      description:
        "Totally! Our Insurita family takes pride in the quality customer service that we have. Our customer service team is available Monday to Friday from 9AM to 6PM Eastern Time."
    }
  ];

  panel: number = 0;

  zip: string = "";

  mounted() {
    window.scrollTo(0, 0);
  }

  triggerCall(type: string) {
    if (type === "customer-service") {
      window.open("tel:1(833)508-1036", "_self");
    }

    if (type === "sales") {
      window.open("tel:1(800)307-5785", "_self");
    }
  }

  @State("user") user!: User;
  created() {
    if (Object.keys(this.user).length && auth().currentUser) {
      this.$router.replace({ name: Routes.DashBoard });
    }
  }
}
